import { Box } from '@mui/material'
import { C1CoolDownButton } from 'components/core/button'
import { RecommendationReviewTooltip } from 'components/core/insights'
import { Decision } from 'components/pages/task/action'
import { ApproveIcon } from 'components/pages/task/action/button'
import { ApproveText } from 'components/pages/task/action/messages'
import { OpenDialogType } from 'components/pages/task/dropdown'
import { canActOn } from 'components/pages/task/state'
import { TaskValue } from 'lib/actions/task'
import { TaskActionType } from 'pbts/c1/api/task/v1/task'
import { Dispatch, SetStateAction } from 'react'
import { TaskActionButton } from './styles'
import { OnActionFunc } from '.'

type ApproveActionButtonProps = {
    task: TaskValue
    onAction: OnActionFunc
    setOpenDialog: (od: OpenDialogType) => void
    setTaskActionTask: Dispatch<SetStateAction<TaskValue>>
}

export const ApproveActionButton = ({
    task,
    onAction,
    setOpenDialog,
    setTaskActionTask,
}: ApproveActionButtonProps): React.ReactElement | null => {
    const taskId = task.id

    if (!canActOn(task, TaskActionType.APPROVE)) {
        return null
    }

    return (
        <RecommendationReviewTooltip task={task}>
            <Box sx={TaskActionButton.item}>
                <C1CoolDownButton
                    startIcon={<ApproveIcon task={task} />}
                    variant="outlined"
                    color="primary"
                    key={`components_task_list_approve_option_${taskId}`}
                    coolDown={1000}
                    onClick={(): void => {
                        const instance = task.policy?.current?.instance
                        const requiresComment =
                            instance &&
                            instance.oneofKind === 'approval' &&
                            instance.approval.approval?.requireApprovalReason
                        if (requiresComment) {
                            setTaskActionTask(task)
                            setOpenDialog('approve')
                        } else {
                            onAction(
                                {
                                    decision: Decision.Approve,
                                    comment: '',
                                    policyStepId: task.policy?.current?.id,
                                },
                                task,
                            )
                        }
                    }}
                    disabled={!canActOn(task, TaskActionType.APPROVE)}
                >
                    <ApproveText task={task} />
                </C1CoolDownButton>
            </Box>
        </RecommendationReviewTooltip>
    )
}
